import { Currency } from "@api/models/enums/Currency";

export class Amount {
  currency!: Currency
  value!: number
}
